export const LEVEL_FADE_MS = 220

/** Fade from the current opacity so a reversed transition never jumps. */
export class VisibilityFade {
    alpha = 1
    visible = true
    private target?: number
    private from = 1
    private startedAt = 0

    reset(): void {
        this.target = undefined
        this.alpha = 1
        this.visible = true
    }

    update(show: boolean, now = Date.now()): void {
        const target = show ? 1 : 0
        if (this.target === undefined) {
            // A newly loaded, already hidden level should never flash on screen.
            this.alpha = target
            this.from = target
            this.target = target
            this.startedAt = now
        } else {
            if (this.target !== target) {
                this.from = this.alpha
                this.target = target
                this.startedAt = now
            }
            const progress = Math.max(0, Math.min(1, (now - this.startedAt) / LEVEL_FADE_MS))
            this.alpha = this.from + (target - this.from) * progress
        }
        this.visible = show || this.alpha > 0
    }
}
